export default function trimString(string, length) {
  if (string === void 0) {
    string = '';
  }
  if (length === void 0) {
    length = 0;
  }
  if (string.length <= length) {
    return string;
  }
  return `${string.slice(0, length)}...`;
}